/**
 * 스크롤 잠금 공통 컨트롤러 — window.__fwScrollLock { lock, unlock } 제공.
 *
 * 라이트박스/모달이 열릴 때 배경 페이지 스크롤을 막는다. 기존엔 각 컨트롤러가
 * document.body.style.overflow='hidden' 만 토글했는데, iOS Safari 는 이것만으로
 * 터치 momentum 스크롤을 못 막아 라이트박스 뒤 배경이 같이 스크롤되는 버그가 있었다.
 *
 * 해결: overflow:hidden(html+body) + touchmove 를 { passive:false } 로 preventDefault.
 *   - 라이트박스(단일 이미지): lock() — 전역 차단(모든 touchmove cancel).
 *   - 모달(폼/목록): lock({ allowScrollWithin: el }) — el 내부의 "실제 스크롤 가능한
 *     영역" 터치는 통과시키고 그 외(배경)만 차단. 모달 내부 폼/목록 스크롤은 살린다.
 *
 * 중첩(예: RSVP 모달 위에 개인정보 상세 모달)을 위해 허용 영역을 스택으로 관리한다.
 * 전역 단일 인스턴스(window.__fwScrollLock)라 중첩 락이 정확히 맞물린다.
 *
 * 다른 컨트롤러보다 먼저 정의되도록 CONTROLLER_CONTRACTS 배열 맨 앞에 등록한다.
 */
export const SCROLL_LOCK_CONTROLLER_SCRIPT = `
<script data-fw-scroll-lock-controller>
(function () {
  if (window.__fwScrollLock) return; // 멱등 — 중복 주입돼도 1회만 정의
  // 중첩 락을 위해 허용 영역(allowScrollWithin)을 스택으로 관리.
  // 라이트박스는 null(전역 차단), 모달은 해당 모달 요소를 push. unlock 시 pop 해
  // 직전 모달의 허용 영역으로 정확히 복원된다(중첩 모달 닫은 뒤 부모 스크롤 회복).
  var stack = [];
  var handler = null;
  var prevHtmlOverflow = '';
  var prevBodyOverflow = '';

  // 터치 대상의 조상 중, 내용이 넘쳐 실제로 스크롤되는 컨테이너가 allowEl 안에 있으면 true.
  // (overflow auto/scroll 이면서 scrollHeight > clientHeight 인 요소)
  function inScrollableWithin(target, allowEl) {
    var n = target;
    while (n && n !== document.body && n.nodeType === 1) {
      if (allowEl && (n === allowEl || allowEl.contains(n))) {
        var oy = '';
        try { oy = getComputedStyle(n).overflowY; } catch (e) { oy = ''; }
        if ((oy === 'auto' || oy === 'scroll') && n.scrollHeight > n.clientHeight) return true;
      }
      n = n.parentNode;
    }
    return false;
  }

  function onTouchMove(e) {
    var allowEl = stack.length ? stack[stack.length - 1] : null;
    // 모달 모드: 내부 스크롤 영역이면 통과, 그 외(배경)는 차단
    if (allowEl && inScrollableWithin(e.target, allowEl)) return;
    if (e.cancelable) e.preventDefault();
  }

  function lock(opts) {
    opts = opts || {};
    if (stack.length === 0) {
      prevHtmlOverflow = document.documentElement.style.overflow;
      prevBodyOverflow = document.body.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
      handler = onTouchMove;
      document.addEventListener('touchmove', handler, { passive: false });
    }
    stack.push(opts.allowScrollWithin || null);
  }

  function unlock() {
    if (stack.length === 0) return;
    stack.pop();
    if (stack.length > 0) return;
    if (handler) document.removeEventListener('touchmove', handler, { passive: false });
    handler = null;
    document.documentElement.style.overflow = prevHtmlOverflow;
    document.body.style.overflow = prevBodyOverflow;
  }

  window.__fwScrollLock = { lock: lock, unlock: unlock };
})();
</script>
`;
//# sourceMappingURL=scroll-lock.js.map